export default __webpack_public_path__ + "static/media/hungryMonsterImageOne.776adfc2.png";